import format from 'date-fns/format';
import Video from 'common/models/video';
import { computed } from 'mobx';
import { DATETIME_DISPLAY_FORMAT } from 'show-page/constants/config';


class ShowPageVideo extends Video {
    constructor(showStore, props) {
        super(props);
        this.store = showStore;
    }

    destroy() {
        super.destroy();
        this.store = null;
    }

    /*=======================================
    =            Computed Values            =
    =======================================*/

    @computed get expirationDateFormatted() {
        const expirationDate = this.expirationDate ? this.expirationDate * 1000 : 0;
        return expirationDate ? format(expirationDate, DATETIME_DISPLAY_FORMAT) : null;
    }

    @computed get fullIdentifier() {
        const s = parseInt(this.seasonNumber, 10);
        const ep = parseInt(this.episodeNumber, 10);
        return (s && ep) ? (`S${s}` + (ep ? ` EP${ep}` : '')) : null;
    }

    @computed get identifier() {
        return parseInt(this.episodeNumber, 10) ? `Ep ${this.episodeNumber}` : null;
    }

    @computed get shareUrl() {
        return `${this.store.shareUrl}/${this.slug}/`;
    }

    @computed get url() {
        return `${this.store.baseUrl}/${this.slug}/`;
    }
}


export default ShowPageVideo;



/** WEBPACK FOOTER **
 ** ./src/show-page/models/video.js
 **/